export default "__VITE_ASSET__9eb2e4df__"